export enum UnitType {
  COPE = 'COPE',
  PAKO = 'PAKO',
  KUTI = 'KUTI'
}

export enum TransactionType {
  IN = 'IN',
  OUT = 'OUT',
  DALJE_KLINIKE = 'DALJE_KLINIKE'
}

export enum NotificationType {
  LOW_STOCK = 'LOW_STOCK',
  EXPIRY_WARNING = 'EXPIRY_WARNING'
}

export interface Product {
  id?: number;
  name: string;
  sku: string;
  category?: string;
  unitType: UnitType;
  isImport: boolean;
  lowStockThreshold: number;
  unitPrice?: number;
}

export interface InventoryTransaction {
  id?: number;
  productId: number;
  productName?: string;
  transactionType: TransactionType;
  quantity: number;
  unitPrice?: number;
  totalValue?: number;
  batchNumber?: string;
  expiryDate?: string;
  supplier?: string;
  reason?: string;
  notes?: string;
  createdById?: number;
  createdByUsername?: string;
  transactionDate?: string;
  createdAt?: string;
}

export interface InventoryIn {
  productId: number;
  quantity: number;
  unitPrice?: number;
  batchNumber?: string;
  expiryDate?: string;
  supplier?: string;
  notes?: string;
}

export interface InventoryOut {
  productId: number;
  batchId?: number;
  quantity: number;
  transactionType?: TransactionType;
  reason?: string;
  notes?: string;
}

export interface CurrentStock {
  id?: number;
  productId: number;
  productName?: string;
  productSku?: string;
  quantity: number;
  lowStockThreshold?: number;
  totalValue?: number;
  lastUpdated?: string;
  unitType?: UnitType;
}

export interface BatchInventory {
  id?: number;
  productId: number;
  productName?: string;
  batchNumber: string;
  quantityRemaining: number;
  expiryDate?: string;
  unitPrice?: number;
  entryDate?: string;
  unitType?: UnitType;
}

export interface Notification {
  id?: number;
  type: NotificationType;
  productId?: number;
  productName?: string;
  message: string;
  isRead: boolean;
  createdAt?: string;
}

export interface Dashboard {
  totalProducts: number;
  totalInventoryValue: number;
  lowStockCount: number;
  expiringSoonCount: number;
  recentMovements?: StockMovement[];
}

export interface StockMovement {
  id?: number;
  productName: string;
  transactionType: TransactionType;
  quantity: number;
  totalValue?: number;
  transactionDate?: string;
}

export interface ReportFilter {
  startDate?: string;
  endDate?: string;
  productId?: number;
  category?: string;
}

